<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="d-flex align-items-center justify-content-between">
      <h4 class="mb-0 font-size-18 c-filemanager-sidebar me-md-2">{{ title }}</h4>
      <div class="page-title-right w-100">
        <ol class="breadcrumb m-0">
          <ng-container *ngFor="let item of breadcrumbItems; let i = index">
            <li class="breadcrumb-item fw-600" *ngIf="!item.active"><a href="javascript: void(0);" (click)="handleBreadCrumd(item, i)">{{ item.label }}</a>
            </li>
            <li class="breadcrumb-item fw-600 active" *ngIf="item.active">{{ item.label }}
            </li>
          </ng-container>
        </ol>
      </div>
    </div>
  </div>
</div>
